export default {
  name: 'auto-ticket-create',
  translationKey: 'auto-ticket-create-module',
  routePrefix: 'auto-ticket-create',
  routeNamePrefix: 'admin.auto-ticket-create',
  directRoutesAvailable: false,
}
